// Copyright 2025 Imprivata, Inc. All rights reserved.

import { useMutation } from '@tanstack/react-query';
import type { UserUnlockRequest } from '../../../../api/types';
import { unlockImprIdpUser } from '../../../../api/portalServices';

export type UnlockUser = {
  unlockRequest: UserUnlockRequest;
};

export const useUnlockUser = () => {
  return useMutation<void, Error, UnlockUser>({
    mutationFn: (data: UnlockUser) => unlockImprIdpUser(data.unlockRequest),
  });
};

export default { useUnlockUser };
